/* MKPBR 01/10/2026 - CARRINHO LATERAL (gaveta). Documentacao em snippets/mkpbr-cdrw.liquid.
   Expoe window.MKCD para o assets/mkpbr-cdrw-offer.js (popup do Add to cart e blocos de sugestao).
   17/10/2026 (conversao): bloco da oferta de 30% dentro da gaveta ([data-mkcd-u2], preenchido pelo
   assets/mkpbr-cdrw-2u.js); botoes de pagamento rapido da Shopify (Shop Pay, Apple Pay, Google Pay, PayPal)
   logo abaixo do Finalizar compra (vem prontos do Liquid em #mkcd-xbtn e sao movidos para a gaveta, nunca
   redesenhados); aviso do proximo degrau do frete em verde, com barra de progresso. */
(function(){
  'use strict';
  if (window.MKCD) return;
  var D = document, W = window;
  function $(s, r){ return (r || D).querySelector(s); }
  function readJSON(id){ var e = D.getElementById(id); if (!e) return null; try { return JSON.parse(e.textContent); } catch (x) { return null; } }
  var CFG = readJSON('mkcd-cfg'), T = readJSON('mkcd-t');
  if (!CFG || !T || !W.fetch) return;
  var ROOT = CFG.root || '/'; if (ROOT.slice(-1) !== '/') ROOT += '/';
  var RTL = !!CFG.rtl;

  function tr(k, v){ var s = T[k] || ''; if (v) for (var x in v) s = s.split('[' + x + ']').join(v[x]); return s; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function pub(n, d){ try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {} }

  /* dinheiro no formato do mercado, deduzido de uma amostra que a Shopify renderizou (mesma tecnica do mkpbr-fbt) */
  var MF = (function(sample){
    var fb = function(c){ return (c / 100).toFixed(2); };
    if (!sample) return fb;
    var m = String(sample).match(/\d[\d.,\s  ’']*\d|\d/); if (!m) return fb;
    var core = m[0], pre = String(sample).slice(0, m.index), suf = String(sample).slice(m.index + core.length);
    var dec = 0, dot = '.', head = core, tail = core.match(/([.,])(\d{2})$/);
    if (tail) { dec = 2; dot = tail[1]; head = core.slice(0, core.length - 3); }
    var g = head.match(/[^\d]/), grp = g ? g[0] : '';
    return function(c){
      var neg = c < 0, s = dec ? (Math.abs(c) / 100).toFixed(dec) : String(Math.round(Math.abs(c) / 100)), parts = s.split('.');
      return (neg ? '−' : '') + pre + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp) + (dec ? dot + (parts[1] || '00') : '') + suf;
    };
  })(CFG.sample);

  /* faixas do desconto por quantidade (Pumper): [[unidades, %], ...] */
  var TIERS = (CFG.tiers || []).slice().sort(function(a, b){ return a[0] - b[0]; });
  function tierFor(u){ var p = 0; for (var i = 0; i < TIERS.length; i++) if (u >= TIERS[i][0]) p = TIERS[i][1]; return p; }
  function nextTier(u){ for (var i = 0; i < TIERS.length; i++) if (u < TIERS[i][0]) return TIERS[i]; return null; }
  var OFF = String(CFG.off || '').toLowerCase().split('|').map(function(s){ return s.trim(); }).filter(Boolean);

  function sizeImg(u, w){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  function localUrl(u){ if (!u) return '#'; if (ROOT !== '/' && u.charAt(0) === '/' && u.indexOf(ROOT) !== 0) return ROOT.slice(0, -1) + u; return u; }

  var state = { cart: null, open: false };
  var hooks = { render: [], beforeCheckout: [] };
  var el = null, lastFocus = null, hasX = false;

  /* ---------- rede: chamadas nossas nao reabrem a gaveta pelo "espiao" de fetch ---------- */
  var mine = 0;
  function api(path, opts){
    var o = { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } };
    if (opts) for (var k in opts) o[k] = opts[k];
    mine++; var p; try { p = fetch(ROOT + path, o); } finally { mine--; }
    return p.then(function(r){
      return r.json().catch(function(){ return null; }).then(function(j){
        if (!r.ok) { var e = new Error((j && (j.description || j.message)) || ('http ' + r.status)); e.status = r.status; e.body = j; throw e; }
        return j;
      });
    });
  }
  function syncCount(c){
    try {
      D.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent = c.item_count; e.hidden = !(c.item_count > 0); });
      if (W.MK26 && MK26.setCount) MK26.setCount(c.item_count);
    } catch (e) {}
  }
  function after(c){
    state.cart = c; syncCount(c); render();
    try { if (W.MKPBR_SHIP && MKPBR_SHIP.refresh) setTimeout(MKPBR_SHIP.refresh, 40); } catch (e) {}
    return c;
  }
  function refresh(){ return api('cart.js', { method: 'GET', cache: 'no-store' }).then(after); }
  /* incluiu = deu certo, mesmo que a releitura do carrinho falhe (senao o cliente tentaria de novo e duplicaria) */
  function add(items, opts){
    return api('cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function(r){ return refresh().catch(function(){}).then(function(){ if (!opts || opts.open !== false) openD(true); return r; }); });
  }
  function change(key, q){ return api('cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: q }) }).then(after); }

  /* qualquer outra parte da loja que inclua no carrinho (FBT, cartoes da PDP, apps) -> abre a gaveta */
  var RX_ADD = /\/cart\/add(\.js)?(\?|$)/, RX_CHG = /\/cart\/(change|update|clear)(\.js)?(\?|$)/;
  function seen(u, ok){
    if (RX_ADD.test(u)) { if (ok) setTimeout(function(){ refresh().then(openD).catch(function(){}); }, 30); }
    else if (RX_CHG.test(u) && state.open) setTimeout(function(){ refresh().catch(function(){}); }, 30);
  }
  var of = W.fetch;
  W.fetch = function(i){
    var u = typeof i === 'string' ? i : (i && (i.url || i.href)) || String(i || ''), self = mine > 0, p = of.apply(this, arguments);
    if (!self) p.then(function(r){ seen(u, r && r.ok); }, function(){});
    return p;
  };
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    var x = this, url = String(u || '');
    if (RX_ADD.test(url) || RX_CHG.test(url)) x.addEventListener('load', function(){ seen(url, x.status >= 200 && x.status < 300); });
    return oo.apply(this, arguments);
  };

  /* ---------- montagem ---------- */
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';
  function build(){
    if (el) return;
    el = D.createElement('div'); el.className = 'mkcd'; if (RTL) el.setAttribute('dir', 'rtl');
    el.innerHTML = '<button class="mkcd__veil" type="button" tabindex="-1" aria-label="' + esc(tr('close')) + '" data-mkcd-close></button>' +
      '<aside class="mkcd__panel" role="dialog" aria-modal="true" aria-labelledby="mkcd-h" tabindex="-1">' +
      '<header class="mkcd__hd"><h2 id="mkcd-h"></h2><button class="mkcd__x" type="button" data-mkcd-close aria-label="' + esc(tr('close')) + '">&times;</button></header>' +
      '<div class="mkcd__tier" data-mkcd-tier hidden></div>' +
      '<div class="mkcd__body"><div data-mkcd-lines></div><section class="mkcd__blk mkcd__blk--u2" data-mkcd-u2 hidden></section><section class="mkcd__blk" data-mkcd-lad hidden></section><section class="mkcd__blk" data-mkcd-up hidden></section></div>' +
      '<footer class="mkcd__ft"><div data-mkcd-ft></div><div class="mkcd__xb" data-mkcd-xb hidden></div><div data-mkcd-ft2></div></footer></aside>';
    D.body.appendChild(el);
    /* pagamento rapido: o elemento da Shopify ja vem montado pelo Liquid; so muda de lugar uma vez */
    var xs = D.getElementById('mkcd-xbtn'), xb = $('[data-mkcd-xb]', el);
    if (xs && xs.firstElementChild) {
      xb.innerHTML = '<p class="mkcd__xor"><span>' + esc(tr('xor')) + '</span></p>';
      while (xs.firstChild) xb.appendChild(xs.firstChild);
      if (xs.parentNode) xs.parentNode.removeChild(xs);
      hasX = true;
    }
    el.addEventListener('click', onClick);
    el.addEventListener('submit', onSubmit);
  }
  function lineHTML(it){
    var dl = 0; (it.line_level_discount_allocations || []).forEach(function(a){ dl += a.amount; });
    var orig = it.original_line_price, fin = it.final_line_price, pct = (orig > 0 && dl > 0) ? Math.round(dl * 100 / orig) : 0;
    var vt = (it.product_has_only_default_variant || !it.variant_title) ? '' : it.variant_title, u = localUrl(it.url);
    return '<li class="mkcd__line" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
      '<a class="mkcd__img" href="' + esc(u) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(sizeImg(it.image, 160)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
      '<div><div class="mkcd__lt"><div><a class="mkcd__ttl" href="' + esc(u) + '">' + esc(it.product_title) + '</a>' + (vt ? '<div class="mkcd__var">' + esc(vt) + '</div>' : '') + '</div>' +
      '<button type="button" class="mkcd__rm" data-mkcd-rm aria-label="' + esc(tr('rm')) + '">' + TRASH + '</button></div>' +
      '<div class="mkcd__lb"><div class="mkcd__q" role="group" aria-label="' + esc(tr('qty')) + '"><button type="button" data-mkcd-dec aria-label="−"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button><span>' + it.quantity + '</span><button type="button" data-mkcd-inc aria-label="+">+</button></div>' +
      '<div class="mkcd__pr">' + (dl > 0 ? '<s>' + MF(orig) + '</s>' : '') + '<b>' + MF(fin) + '</b>' + (pct ? '<div class="mkcd__dl"><bdi dir="ltr">−' + pct + '%</bdi></div>' : '') + '</div></div></div></li>';
  }
  function shipState(c){
    try { if (W.MKPBR_SHIP && MKPBR_SHIP.compute) return MKPBR_SHIP.compute({ total_price: c.total_price, item_count: c.item_count, currency: c.currency }); } catch (e) {}
    return null;
  }
  function row(label, val, cls){ return '<div class="mkcd__sum' + (cls ? ' ' + cls : '') + '"><span>' + esc(label) + '</span><span>' + val + '</span></div>'; }
  function renderTier(n){
    var box = $('[data-mkcd-tier]', el);
    if (!TIERS.length || !n) { box.hidden = true; return; }
    var nt = nextTier(n), cur = tierFor(n), msg, cls = '';
    if (!nt) { msg = tr('tmax', { p: cur }); cls = ' is-max'; }
    else { var d = nt[0] - n; msg = d === 1 ? tr('tnext1', { p: nt[1] }) : tr('tnext', { n: d, p: nt[1] }); }
    box.innerHTML = '<p class="mkcd__tmsg' + cls + '">' + esc(msg) + '</p><div class="mkcd__bar">' + TIERS.map(function(t){
      return '<div class="mkcd__seg' + (n >= t[0] ? ' is-on' : '') + '"><i></i>' + esc(tr('seg', { q: t[0] })) + ' · <bdi dir="ltr">' + t[1] + '%</bdi></div>';
    }).join('') + '</div>';
    box.hidden = false;
  }
  function renderFoot(){
    var c = state.cart, f = $('[data-mkcd-ft]', el), f2 = $('[data-mkcd-ft2]', el), xb = $('[data-mkcd-xb]', el);
    xb.hidden = !(hasX && c.item_count > 0);
    if (!c.item_count) { f.innerHTML = ''; f2.innerHTML = '<button type="button" class="mkcd__cont" data-mkcd-close>' + esc(tr('cont')) + '</button>'; return; }
    var s = shipState(c), h = row(tr('sub'), MF(c.total_price));
    if (c.total_discount > 0) h += row(tr('save'), MF(c.total_discount), 'is-save');
    var frete = null;
    if (s && !s.calculado && s.freteAtual != null) frete = Math.round(s.freteAtual * 100);
    h += row(tr('shipest'), frete == null ? esc(tr('calc')) : (frete === 0 ? esc(tr('free')) : MF(frete)));
    if (s && s.proximo && s.faltaProximo > 0) {
      var x = MF(Math.round(s.faltaProximo * 100)), pct = 0;
      /* barra: quanto do caminho ate o proximo degrau ja foi feito (minimo 4% para a barra aparecer) */
      if (s.atual && s.proximo.de > s.atual.de) pct = Math.max(4, Math.min(100, Math.round((s.total - s.atual.de) * 100 / (s.proximo.de - s.atual.de))));
      h += '<div class="mkcd__ship">' + (pct ? '<div class="mkcd__sbar" aria-hidden="true"><i style="width:' + pct + '%"></i></div>' : '') +
        '<p class="mkcd__hint">' + esc(s.proximo.frete === 0 ? tr('sfree', { x: x }) : tr('snext', { x: x, b: MF(Math.round(s.proximo.frete * 100)) })) + '</p></div>';
    }
    if (frete != null) h += row(tr('total'), MF(c.total_price + frete), 'is-tot');
    h += '<form method="post" action="' + esc(CFG.cart || (ROOT + 'cart')) + '" data-mkcd-form><input type="hidden" name="checkout" value="1"><button type="submit" class="mkcd__co">' + esc(tr('co')) + '</button></form>';
    f.innerHTML = h;
    f2.innerHTML = '<button type="button" class="mkcd__cont" data-mkcd-close>' + esc(tr('cont')) + '</button><p class="mkcd__tax">' + esc(tr('tax')) + '</p>';
  }
  function render(){
    if (!el || !state.cart) return;
    var c = state.cart, n = c.item_count;
    $('#mkcd-h', el).innerHTML = esc(tr('title')) + (n ? ' <span>(' + esc(n === 1 ? tr('items1') : tr('items', { n: n })) + ')</span>' : '');
    renderTier(n);
    $('[data-mkcd-lines]', el).innerHTML = n ? '<ul class="mkcd__lines">' + c.items.map(lineHTML).join('') + '</ul>' : '<p class="mkcd__empty">' + esc(tr('empty')) + '</p>';
    if (!n) { $('[data-mkcd-u2]', el).hidden = true; $('[data-mkcd-lad]', el).hidden = true; $('[data-mkcd-up]', el).hidden = true; }
    renderFoot();
    hooks.render.forEach(function(f){ try { f(c, el); } catch (e) { if (W.console) console.warn('[mkcd]', e); } });
  }

  /* ---------- abrir / fechar ---------- */
  /* fresh = o carrinho acabou de ser lido; sem ele, mostra o que tem e rele (outra aba, voltar do checkout) */
  function openD(fresh){
    build();
    if (state.cart) render();
    if (!fresh || !state.cart) refresh().catch(function(){});
    if (state.open) return;
    state.open = true; lastFocus = D.activeElement;
    el.classList.add('is-open'); D.documentElement.classList.add('mkcd-lock');
    setTimeout(function(){ try { $('.mkcd__panel', el).focus({ preventScroll: true }); } catch (e) {} }, 40);
    pub('mkpbr_cdrw_open', { items: state.cart ? state.cart.item_count : null });
  }
  function closeD(){
    if (!el || !state.open) return;
    state.open = false; el.classList.remove('is-open'); D.documentElement.classList.remove('mkcd-lock');
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- cliques dentro da gaveta ---------- */
  function onClick(e){
    var t = e.target, b;
    if (t.closest('[data-mkcd-close]')) { e.preventDefault(); closeD(); return; }
    var li = t.closest('.mkcd__line');
    if (li) {
      var key = li.getAttribute('data-key'), q = Number(li.getAttribute('data-q')) || 1, nq = null;
      if (t.closest('[data-mkcd-inc]')) nq = q + 1; else if (t.closest('[data-mkcd-dec]')) nq = Math.max(1, q - 1); else if (t.closest('[data-mkcd-rm]')) nq = 0;
      if (nq != null && nq !== q) { li.classList.add('is-busy'); change(key, nq).catch(function(){ refresh().catch(function(){}); }); }
      return;
    }
    b = t.closest('[data-mkcd-addv]');
    if (b && !b.disabled) {
      e.preventDefault(); b.disabled = true;
      var lbl = b.textContent, src = b.getAttribute('data-src') || '';
      add([{ id: Number(b.getAttribute('data-mkcd-addv')), quantity: 1 }], { open: false })
        .then(function(){ pub('mkpbr_cdrw_add', { variant: b.getAttribute('data-mkcd-addv'), src: src }); })
        .catch(function(){ b.disabled = false; b.textContent = tr('err'); setTimeout(function(){ b.textContent = lbl; }, 2200); });
    }
  }
  function onSubmit(e){
    var f = e.target; if (!f.matches('[data-mkcd-form]')) return;
    e.preventDefault();
    var btn = $('.mkcd__co', f); if (btn) btn.disabled = true;
    /* o rodape pode ter sido redesenhado enquanto um gancho rodava (o formulario antigo saiu da pagina) */
    var go = function(){ var g = f.isConnected ? f : $('[data-mkcd-form]', el); if (g) HTMLFormElement.prototype.submit.call(g); else W.location.href = ROOT + 'checkout'; };
    var chain = Promise.resolve(true);
    hooks.beforeCheckout.forEach(function(h){ chain = chain.then(function(ok){ return ok === false ? false : h(state.cart); }); });
    chain.then(function(ok){ if (ok !== false) go(); else if (btn) btn.disabled = false; }, go);
  }
  D.addEventListener('keydown', function(e){ if (e.key === 'Escape' && state.open && !D.querySelector('.mkcp')) closeD(); });   /* com popup aberto, o Esc e do popup */
  D.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-cart]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault(); openD();
  }, true);
  W.addEventListener('pageshow', function(e){ if (e.persisted && state.open) refresh().catch(function(){}); });
  D.documentElement.classList.add('mkcd-on');

  W.MKCD = { cfg: CFG, t: tr, esc: esc, MF: MF, tierFor: tierFor, nextTier: nextTier, tiers: TIERS, off: OFF, root: ROOT, rtl: RTL,
             open: openD, close: closeD, refresh: refresh, add: add, api: api, pub: pub, sizeImg: sizeImg, localUrl: localUrl,
             shipState: shipState, hooks: hooks, cart: function(){ return state.cart; }, isOpen: function(){ return state.open; },
             el: function(){ build(); return el; }, render: render, hasExpress: function(){ return hasX; } };
  try { D.dispatchEvent(new CustomEvent('mkcd:ready')); } catch (e) {}
})();